import React from 'react';
import { MdDone } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
import {
  Container, Content, ContentContainer, Header, Price, Title, Parcel,
  LoginContainer,
  LoginText,
} from './styles';
import theme from '../../theme';
import ModalButton from '../ModalButton';
import { ChallengeDetailType } from '../../types/Challenger';

interface Props {
  challengeDetail: ChallengeDetailType
}

export default function ChallengeSubscriptionCard({ challengeDetail }: Props) {
  const auth = useSelector((state: RootState) => state.auth);
  const { token } = auth;

  const navigate = useNavigate();

  const redirectToPayment = () => {
    const tok = token ? `?token=${token}` : '';
    window.open(`https://pay.corridaperfeita.com/pay/product/${challengeDetail.slug}/${tok}`);
  };

  const redirectToLogin = () => {
    auth.path = `/club/desafios/${challengeDetail.slug}`;
    navigate('/login');
  };

  return (
    <Container>
      <Header>
        <Title>Inscrição + Medalha</Title>
        <Price>{challengeDetail.price.toFixed(2)}</Price>
        <Parcel>{`em até ${challengeDetail.installments} X ${(challengeDetail.price / challengeDetail.installments).toFixed(2)}`}</Parcel>
      </Header>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Inscrição no desafio</Content>
      </ContentContainer>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Medalha de finisher exclusiva</Content>
      </ContentContainer>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Acompanhamento do progresso</Content>
      </ContentContainer>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Visualização de ruas da sua localização virtual</Content>
      </ContentContainer>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Medalha enviada após a conclusão</Content>
      </ContentContainer>
      <ContentContainer>
        <MdDone size={18} color={theme.colors.graph} />
        <Content>Frete grátis da medalha para todo o Brasil</Content>
      </ContentContainer>

      <ModalButton title="INSCREVA-SE AGORA" onPress={redirectToPayment} style={{ padding: 8, margin: 23 }} />

      {!token && (
        <LoginContainer>
          <LoginText> Já fez sua inscrição?</LoginText>
          <ModalButton title="ACOMPANHE O SEU DESAFIO" onPress={redirectToLogin} style={{ padding: 8 }} secondary />
        </LoginContainer>
      )}
    </Container>
  );
}
